/**
 * Logger utility - all logging must use string concatenation only
 * Format: console.log("[Module] message=" + value)
 * Silenced in test mode (NODE_ENV=test)
 */

import { logDebug, logError } from "./logging";

export const logger = {
  log: (module: string, message: string, value?: unknown): void => {
    if (value !== undefined) {
      logDebug("[" + module + "] " + message + "=" + String(value));
    } else {
      logDebug("[" + module + "] " + message);
    }
  },

  error: (module: string, message: string, error?: unknown): void => {
    if (error !== undefined) {
      const errorStr = error instanceof Error ? error.message : String(error);
      logError("[" + module + "] " + message + " error=" + errorStr);
    } else {
      logError("[" + module + "] " + message);
    }
  },
};
